import React, { memo, useMemo } from 'react';
import { View, StyleSheet } from 'react-native';
import { useDerivedValue } from 'react-native-reanimated';
import { Indicator } from 'design-system';
import { rem } from 'design-system/values';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import createStyleSheets from 'utils/createStyleSheets';
import { useAppSelector } from 'store/hooks';
import { LINE_CHART_WRAPPER_HEIGHT, PORTFOLIO_CHART_DEFAULT_PERIOD, PORTFOLIO_CHART_DEFAULT_PERIOD_SECCL, } from 'features/invest/constants';
import ChartPath from './Chart';
import ChartPointer from './Chart/ChartPointer';
import PeriodSwitch from './PeriodSwitch';
import ModeSwitch from './ModeSwitch';
import * as debug from '../debug';
import { selectIsTradingAccountAlpaca } from '../reducers/selectors';
import { isWeb } from '../../../constants';
export const DEFAULT_PERIOD = PORTFOLIO_CHART_DEFAULT_PERIOD;
const PERIODS_CONTAINER_HEIGHT = rem(26 + 32);
const CHART_HEIGHT = LINE_CHART_WRAPPER_HEIGHT - PERIODS_CONTAINER_HEIGHT - rem(20);
const PortfolioChart = (props) => {
    const { width: TOTAL_WIDTH } = useAppFrameDimensions(props.isInTab || isWeb);
    const isTradingAccountAlpaca = useAppSelector(selectIsTradingAccountAlpaca);
    const CHART_WIDTH = useMemo(() => TOTAL_WIDTH - rem(32), [TOTAL_WIDTH]);
    const { loading, contextValue, refresh, changeMode } = props;
    const colors = useColors();
    const styleSet = useMemo(() => createStyleSheets((colors) => ({
        container: {
            width: CHART_WIDTH,
            height: LINE_CHART_WRAPPER_HEIGHT,
        },
        loadingOverlay: {
            ...StyleSheet.absoluteFillObject,
            bottom: PERIODS_CONTAINER_HEIGHT,
            backgroundColor: `${String(colors.cards.onDark)}80`,
        },
        periodsContainer: {
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: PERIODS_CONTAINER_HEIGHT,
            justifyContent: 'flex-end',
        },
        modeContainer: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: CHART_WIDTH,
            height: PERIODS_CONTAINER_HEIGHT,
            justifyContent: 'flex-end',
        },
    })), [CHART_WIDTH]);
    const styles = useStyles(styleSet);
    const colorValue = useDerivedValue(() => colors.elements.brand, [colors.elements.brand]);
    return (<View style={styles.container}>
      <ChartPath hapticsEnabled strokeWidth={1.66} color={colorValue} width={CHART_WIDTH} height={CHART_HEIGHT} selectedOpacity={0.5} selectedStrokeWidth={1.66} contextValue={contextValue}/>
      <ChartPointer contextValue={contextValue} height={CHART_HEIGHT + rem(20)}/>
      <View style={styles.periodsContainer}>
        <PeriodSwitch onSelect={refresh} isInTab={props.isInTab} scrollToEnd={!isTradingAccountAlpaca} backgroundColor={colors.buttons.brandGroup} defaultPeriod={isTradingAccountAlpaca ? DEFAULT_PERIOD : PORTFOLIO_CHART_DEFAULT_PERIOD_SECCL}/>
      </View>
      {debug.showPortfolioModeSwitch ? (<View style={styles.modeContainer}>
          <ModeSwitch onSelect={changeMode} defaultPeriod="Equity"/>
        </View>) : null}
      {loading ? <Indicator dark style={styles.loadingOverlay}/> : null}
    </View>);
};
export default memo(PortfolioChart);
